import { PERMISSIONS } from 'config/vars'

export enum Permission {
  CAN_RECOMMEND_CONTENT = 'can_recommend_content',
  CAN_MANAGE_ACTIVITIES = 'can_manage_activities',
  CAN_MANAGE_RUNNING_RECORDS = 'can_manage_running_records',
  CAN_MANAGE_READING_GOALS = 'can_manage_reading_goals',
  CAN_ACCESS_USAGE_ANALYTICS = 'can_access_usage_analytics',
  CAN_MANAGE_USERS = 'can_manage_users',
  CAN_MANAGE_ENTITIES = 'can_manage_entities',
  CAN_MANAGE_PERMISSIONS = 'can_manage_permissions',
  CAN_MANAGE_COLLECTIONS = 'can_manage_collections',
  CAN_ACCESS_TEACHER_PANEL = 'can_access_teacher_panel',
  CAN_DELETE_USERS = 'can_delete_users',
  CAN_MODERATE_DISCUSSIONS = 'can_moderate_discussions'
}

export const canNavigateBetweenEntitiesRegisteredToMe = (
  permissions: string
) => {
  if (!permissions) return false

  const permissionsArr = permissions.trim().split(' ')
  return permissionsArr.includes(
    PERMISSIONS.CAN_NAVIGATE_BETWEEN_ENTITIES_REGISTERED_TO_ME
  )
}
